/* ===== MedBound — waitlist per i prodotti "coming soon" =====
   Click su una card [data-waitlist] -> modal per lasciare l'email.
   L'email viene inviata a Shopify (POST /contact, form_type=customer) con
   tag "waitlist-<prodotto>" -> finisce in Admin > Clienti, iscritto all'email
   marketing. Copia di backup anche in localStorage (mb_waitlist). */
(function(){
  const KEY = "mb_waitlist";
  const load = () => { try { return JSON.parse(localStorage.getItem(KEY))||[] } catch(e){ return [] } };

  function inject(){
    if(document.getElementById("mbw-ov")) return;
    const css = `<style>
    #mbw-ov{position:fixed;inset:0;background:rgba(0,0,0,.5);opacity:0;visibility:hidden;transition:.25s;z-index:100000;display:flex;align-items:center;justify-content:center;padding:20px}
    #mbw-ov[data-open="1"]{opacity:1;visibility:visible}
    .mbw{background:#fff;border-radius:22px;max-width:430px;width:100%;padding:30px 28px;text-align:center;box-shadow:0 18px 50px rgba(0,0,0,.3);transform:translateY(14px) scale(.97);transition:.25s;font-family:var(--font-body-family,Montserrat,sans-serif)}
    #mbw-ov[data-open="1"] .mbw{transform:none}
    .mbw-eye{width:38px;height:38px;color:#1E4D6F;margin:0 auto 6px;display:block}
    .mbw h3{font-family:var(--font-heading-family,"Passion One",sans-serif);font-weight:400;font-size:26px;margin:0 0 4px;color:#1E4D6F}
    .mbw-p{font-size:14px;color:#555;line-height:1.5;margin:0 0 18px}
    .mbw-p b{color:#111}
    .mbw-row{display:flex;gap:10px}
    .mbw-row input{flex:1;border:1.5px solid #e2e2e2;border-radius:99px;padding:13px 18px;font-size:14px;outline:none;min-width:0}
    .mbw-row input:focus{border-color:#1E4D6F}
    .mbw-row button{background:#D53A2F;color:#fff;border:0;font-weight:800;font-size:14.5px;padding:0 22px;border-radius:99px;cursor:pointer;flex:0 0 auto}
    .mbw-row button:hover{background:#b73225}
    #mbw-prefix{flex:0 0 auto;border:1.5px solid #e2e2e2;border-radius:99px;padding:0 10px;font-size:14px;background:#fff;outline:none;cursor:pointer}
    #mbw-prefix:focus{border-color:#1E4D6F}
    #mbw-go{display:block;width:100%;background:#D53A2F;color:#fff;border:0;font-weight:800;font-size:15px;padding:13px;border-radius:99px;cursor:pointer}
    #mbw-go:hover{background:#b73225}
    @keyframes mbwPop{0%{transform:scale(.3);opacity:0}60%{transform:scale(1.18)}100%{transform:scale(1);opacity:1}}
    .mbw-err{display:none;color:#D53A2F;font-size:12.5px;font-weight:700;margin-top:10px}
    .mbw-ok{display:none;padding:10px 0 2px}
    .mbw-ok .big{font-size:40px;line-height:1;animation:mbwPop .55s ease both}
    .mbw-ok .t{font-weight:800;font-size:16px;margin-top:8px}
    .mbw-ok .s{font-size:13px;color:#666;margin-top:4px}
    .mbw-x{position:absolute;top:14px;right:18px;font-size:22px;background:none;border:0;cursor:pointer;color:#999}
    .mbw{position:relative}
    .mbw-note{font-size:11.5px;color:#aaa;margin-top:14px}
    </style>`;
    const html = `<div id="mbw-ov">
      <div class="mbw" role="dialog" aria-modal="true" aria-label="Waitlist">
        <button class="mbw-x" data-mbw-close aria-label="Schließen">✕</button>
        <svg class="mbw-eye" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"><path d="M3 3l18 18"/><path d="M10.6 5.1A10.5 10.5 0 0 1 12 5c7 0 10 7 10 7a17.4 17.4 0 0 1-3.2 4.2M6.1 6.1A17 17 0 0 0 2 12s3 7 10 7a10.4 10.4 0 0 0 4-.8"/><path d="M9.9 9.9a3 3 0 0 0 4.2 4.2"/></svg>
        <h3>Bald verfügbar</h3>
        <p class="mbw-p"><b id="mbw-name"></b> ist bald da. Lass uns deine Daten da und wir sagen dir Bescheid, sobald es so weit ist — wer zuerst auf der Liste steht, bekommt den Launch-Preis.</p>
        <div id="mbw-form">
          <div class="mbw-row" style="margin-bottom:8px"><input id="mbw-fname" type="text" placeholder="Vor- und Nachname *" aria-label="Vor- und Nachname" required></div>
          <div class="mbw-row" style="margin-bottom:8px"><input id="mbw-mail" type="email" placeholder="Deine E-Mail *" aria-label="Email" required></div>
          <div class="mbw-row" style="margin-bottom:8px;gap:8px"><select id="mbw-prefix" aria-label="Ländervorwahl"><option value="+49" selected>🇩🇪 +49</option><option value="+43">🇦🇹 +43</option><option value="+41">🇨🇭 +41</option><option value="+39">🇮🇹 +39</option><option value="+33">🇫🇷 +33</option><option value="+34">🇪🇸 +34</option><option value="+44">🇬🇧 +44</option><option value="+31">🇳🇱 +31</option><option value="+32">🇧🇪 +32</option><option value="+48">🇵🇱 +48</option><option value="+351">🇵🇹 +351</option><option value="+352">🇱🇺 +352</option><option value="+1">🇺🇸 +1</option></select><input id="mbw-phone" type="tel" placeholder="171 1234567" aria-label="Telefonnummer" required></div>
          <button id="mbw-go">Benachrichtige mich</button>
          <div class="mbw-err" id="mbw-err">Gib einen gültigen Namen, E-Mail und Telefonnummer ein</div>
        </div>
        <div class="mbw-ok" id="mbw-ok"><div class="big">🎉</div><div class="t">Du bist auf der Liste!</div><div class="s">Wir schreiben dir, sobald es verfügbar ist.</div></div>
        <div class="mbw-note">Kein Spam — nur die Launch-Benachrichtigung.</div>
      </div>
    </div>`;
    document.body.insertAdjacentHTML("beforeend", css+html);
    document.getElementById("mbw-go").addEventListener("click", submit);
    document.getElementById("mbw-fname").addEventListener("keydown", e=>{ if(e.key==="Enter") submit(); });
    document.getElementById("mbw-mail").addEventListener("keydown", e=>{ if(e.key==="Enter") submit(); });
    document.getElementById("mbw-phone").addEventListener("keydown", e=>{ if(e.key==="Enter") submit(); });
  }

  let current = null;
  function open(key, name){
    inject();
    current = key;
    document.getElementById("mbw-name").textContent = name || "Dieses Produkt";
    document.getElementById("mbw-form").style.display = "";
    document.getElementById("mbw-ok").style.display = "none";
    document.getElementById("mbw-err").style.display = "none";
    document.getElementById("mbw-ov").dataset.open = "1";
    setTimeout(()=>{ const i=document.getElementById("mbw-mail"); if(i) i.focus(); }, 250);
  }
  const close = () => { const ov=document.getElementById("mbw-ov"); if(ov) ov.dataset.open="0"; };

  function submit(){
    const fname = (document.getElementById("mbw-fname").value||"").trim();
    const mail = (document.getElementById("mbw-mail").value||"").trim();
    const prefix = (document.getElementById("mbw-prefix")||{}).value || "";
    const phoneNum = (document.getElementById("mbw-phone").value||"").trim();
    const phone = (prefix + " " + phoneNum).trim();
    const err = document.getElementById("mbw-err");
    function showErr(m){ err.style.display="block"; err.textContent=m; }
    if(!fname){ showErr("Gib deinen Namen ein."); return; }
    if(!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(mail)){ showErr("Gib eine gültige E-Mail-Adresse ein."); return; }
    if(!phoneNum){ showErr("Gib deine Telefonnummer ein."); return; }
    err.style.display = "none";
    // invio al Google Sheet (riga + email) con nome, email, telefono
    if(window.mbLead) window.mbLead({ name:fname, email:mail, phone:phone, sourceLabel:"Waitlist "+(current||""), tags:["waitlist","waitlist-"+(current||"prodotto")] });
    const list = load();
    list.push({ product: current, name: fname, email: mail, phone: phone, ts: Date.now() });
    try { localStorage.setItem(KEY, JSON.stringify(list)); } catch(e){}
    document.getElementById("mbw-fname").value = "";
    document.getElementById("mbw-mail").value = "";
    document.getElementById("mbw-phone").value = "";
    document.getElementById("mbw-form").style.display = "none";
    document.getElementById("mbw-ok").style.display = "block";
    setTimeout(close, 2600);
  }

  function init(){
    document.addEventListener("click", e=>{
      const x = e.target.closest("[data-mbw-close], #mbw-ov");
      if(x && (e.target.id==="mbw-ov" || e.target.closest("[data-mbw-close]"))){ close(); return; }
      const card = e.target.closest("[data-waitlist]");
      if(card){ e.preventDefault(); open(card.dataset.waitlist, card.dataset.waitlistName); }
    });
    document.addEventListener("keydown", e=>{ if(e.key==="Escape") close(); });
  }
  window.__mbw = { open, close };
  if(document.readyState!=="loading") init(); else document.addEventListener("DOMContentLoaded", init);
})();
